<!-- loading.vue -->
<template>
  <div
    :class="
      orientation == 0 && isMobile ? 'custom-toast-portrait' : 'custom-toast'
    "
    v-if="show"
  >
    <div class="custom-toast-box">
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="less">
.custom-toast {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9999999999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
// 强制横屏
.custom-toast-portrait {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  width: 100vh;
  height: 100vw;
  top: 0;
  left: 100vw;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  transform-origin: 0% 0%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.custom-toast-box {
  width: 30vmin;
  height: 8vmin;
  background-image: url(~@/assets/login/toast.png);
  background-size: 100% 100%;
  position: relative;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10vmin;
  span {
    color: #c3c3c3;
    font-family: "PingFangSC-Regular";
    font-size: 4vmin;
  }
}
</style>
